import request from "./request";
export function getGPTCheckInfo(data) {
    return request({
        url: 'GPTCheck',
        method: 'post',
        data
    })
}

export function getGPTGuess(params) {
    return request({
        url: 'GPTCheck/test',
        method: 'get',
        params
    })
}
export function postGPTGuess(data) {
    return request({
        url: 'GPTCheck/test',
        method: 'post',
        data
    })
}






// WEBPACK FOOTER //
// ./src/api/art.js